import { cn } from 'lib/utils';

const toolFormFieldBaseClassName =
  'rounded-[0.5rem] border-border bg-background text-[13px] shadow-none placeholder:text-muted-foreground transition-[border-color,box-shadow] hover:border-ring/40 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20';

export const toolFormInputClassName = cn(toolFormFieldBaseClassName, 'h-11 px-3');

export const toolFormTextareaClassName = cn(
  toolFormFieldBaseClassName,
  'min-h-[100px] resize-y px-3 py-2'
);

export function getToolFormInputClassName(hasError?: boolean) {
  return cn(
    toolFormInputClassName,
    hasError &&
      'border-destructive hover:border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20'
  );
}

export function getToolFormTextareaClassName(hasError?: boolean) {
  return cn(
    toolFormTextareaClassName,
    hasError &&
      'border-destructive hover:border-destructive focus-visible:border-destructive focus-visible:ring-destructive/20'
  );
}
